<template>
  <v-row no-gutters justify="start" :class="attendeeList.length > 1 ? 'container-attendee' : ''">
    <div
      :cols="attendeeList.length"
      class="pa-0 wrap-attendee"
      v-for="(attendee, index) in attendeeList"
      :key="index"
      :style="containerHeight"
    >
      <v-tooltip bottom color="#131b1e">
        <template v-slot:activator="{ on }">
          <v-avatar
            :color="!attendee.userPicture ? attendee.userDisplayName || attendee.userFullName : '' | iconBackground"
            class="logo avatar"
            :style="[{ 'z-index': 197 - index }, avatarStyle]"
            round
            :size="size"
            v-on="on"
          >
            <div class="avatar-bg" v-if="attendee.userPicture"></div>
            <span class="v-avatar-name" v-if="!attendee.userPicture">
              {{ attendee.userDisplayName || attendee.userFullName | iconFilter }}
            </span>
            <v-img :src="attendee.userPicture" v-else />
          </v-avatar>
        </template>
        <span>
          {{ attendee.userDisplayName || attendee.userFullName }}
        </span>
      </v-tooltip>
      <v-icon
        v-if="mtOrganizerUid == mtCreatorUid && isMtCreator(attendee.userId)"
        @click="openDialog('Attendee')"
        color="#ffc107"
        class="crown"
        :style="position"
      >
        mdi-crown
      </v-icon>
    </div>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Attendee',
  props: {
    isAdd: Boolean,
    mtOrganizerUid: String,
    mtCreatorUid: String,
    list: Array,
    size: String,
    isDisableCrown: Boolean,
    border: String,
    deleteOrgarnizer: Boolean,
  },
  data() {
    return {
      attendeeList: [],
    }
  },
  created() {
    this.makeAttendeeList(this.list)
  },
  methods: {
    makeAttendeeList(list) {
      this.attendeeList = []
      if (list && list.length > 0) {
        for (var item of list) {
          if (item && this.isMtCreator(item.userId, this.mtCreatorUid)) {
            this.attendeeList.push(item)
          }
        }
        // Organizer는 제거 (임시)
        for (let i = 0; i < list.length; i++) {
          if (this.mtOrganizerUid == list[i].userId && this.deleteOrgarnizer) {
            list.splice(i, 1)
          }
        }
        for (let tempItem of list) {
          if (this.attendeeList.length >= 5) return
          else if (tempItem && !this.isMtCreator(tempItem.userId, this.mtCreatorUid)) this.attendeeList.push(tempItem)
        }
      }
    },
    openDialog(type) {
      this.$emit('openDialog', type)
    },
    isMtCreator(val1, val2) {
      // if (!val2) {
      //   return false
      // } else {
      let userId = val1 || this.$store.getters.userInfo.userId
      let organizerId = val2 || this.mtCreatorUid
      return userId === organizerId
      // }
    },
  },
  computed: {
    ...mapGetters(['currentMt']),
    containerHeight() {
      return {
        '--height': this.size + 'px',
      }
    },
    avatarStyle() {
      return {
        '--border-color': this.border,
      }
    },
    position() {
      return {
        '--size': parseInt(this.size) + '%',
        '--font-size': this.size - 12 + 'px',
        '--margin-top': '-' + (parseInt(this.size) - 7) + 'px',
        '--margin-left': '-' + (parseInt(this.size) - 10) + '%',
      }
    },
  },
}
</script>

<style scoped>
.wrap-attendee {
  position: relative;
  display: inline-block;
  /* height: var(--height); */
  margin-left: 0;
  margin-right: -14px;
  border-radius: 50%;
  transition: all 0.3s;
  cursor: default !important;
  width: auto;
}
.v-avatar-name {
  position: relative;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  /* top: 2px; */
}
.v-avatar {
  border: 2px;
  border-style: solid;
  border-color: var(--border-color) !important;
}
.container-attendee:hover .wrap-attendee {
  margin-left: 0px;
  margin-right: -5px;
}
.avatar {
  position: relative;
  margin-left: auto;
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
.crown {
  position: absolute;
  font-size: var(--font-size);
  cursor: default !important;
  top: 50%;
  margin-top: var(--margin-top);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  z-index: 0;
}
</style>
